import { Injectable } from '@angular/core';
import { VALID_PASSWORDS } from '../../config/passwords';

const COOKIE_NAME = 'vggo_auth';
const COOKIE_DAYS = 365;

@Injectable()
export class AuthProvider {

  login(password: string): boolean {
    const match = VALID_PASSWORDS.some(p => p === password);
    if (match) {
      this.setCookie(COOKIE_NAME, '1', COOKIE_DAYS);
    }
    return match;
  }

  logout(): void {
    this.setCookie(COOKIE_NAME, '', -1);
  }

  isLoggedIn(): boolean {
    return this.getCookie(COOKIE_NAME) === '1';
  }

  private setCookie(name: string, value: string, days: number): void {
    const expires = new Date();
    expires.setTime(expires.getTime() + days * 24 * 60 * 60 * 1000);
    document.cookie = `${name}=${value};expires=${expires.toUTCString()};path=/`;
  }

  private getCookie(name: string): string | null {
    const match = document.cookie.match(new RegExp('(?:^|; )' + name + '=([^;]*)'));
    return match ? decodeURIComponent(match[1]) : null;
  }
}



// WEBPACK FOOTER //
// ./src/providers/auth/auth.ts